export default {
  LOAD_CAREER (state, payload) {
    state.careerObject = payload
  },
  LOAD_CAREER_RESULT (state, payload) {
    state.careerResultObject = payload
  },
  LOAD_CAREER_ONE_STOP_INFO (state, payload) {
    state.careerOneStopInfo = payload
  },
  LOAD_GEO_IDS (state, payload) {
    state.geoIdMap = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/career/vuex/mutations.js